import {
  FullScreenModalBody,
  FullScreenModalBodyProps,
  FullScreenModalComponentName,
} from '@components';
import { Dialog, DialogPanel } from '@headlessui/react';

export interface FullScreenModalProps {
  body?: FullScreenModalBodyProps<FullScreenModalComponentName>;
  children?: React.ReactNode;
}

// For all full screens modal. At the moment it is blue
export const FullScreenModal = ({ body, children }: FullScreenModalProps) => {
  return (
    <Dialog as="div" open className="relative z-10" onClose={v => v}>
      <div className="fixed inset-0 overflow-y-auto">
        <DialogPanel
          className={'w-[100vw] h-[100vh] flex items-center justify-center bg-nusa-100 px-6'}>
          <FullScreenModalBody
            {...(body as FullScreenModalBodyProps<FullScreenModalComponentName>)}
          />
        </DialogPanel>
      </div>
      {children}
    </Dialog>
  );
};
